import React from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
} from 'reactstrap';
import Page from 'components/Page';
import Geocode from "react-geocode";
import GoogleMapReact from 'google-map-react';
import BaseService from '../services/BaseService';
import SelectAPI from 'components/SelectAPI';
import Strings from '../strings/Strings';
import PinLocalization from 'components/PinLocalization';
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';
import Loader from 'components/Loader';

class DashboardPage extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      show_form: false,
      id: '',
      status: null,
      statusInvalid: false,
      spot_number: '',
      address: '',
      address_number: '',
      latitude: 0,
      longitude: 0,
      report: false,
      reload: false,
      loading: false,
      color_message: '',
      error_message: '',
      editing: false,
    };
    this.closed = this.closed.bind(this);
    this.toggle = this.toggle.bind(this);

    // Get position
    /* if('geolocation' in navigator){
      const refThis = this
      navigator.geolocation.getCurrentPosition(
        function(position){
          if( position.coords.latitude !== 0 && position.coords.longitude !== 0 ){
            refThis.setState({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          }
        },
        function(error){
          console.log(error);
        }
      );
    } */
    this.alterStatusSpot = this.alterStatusSpot.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

    Geocode.setApiKey(BaseService.KeyGoogleMap);
    Geocode.enableDebug();
    Geocode.fromLatLng(this.state.latitude, this.state.longitude).then(
      response => {
        const { lat, lng } = response.results[0].geometry.location;
        this.setState({
          latitude: lat,
          longitude: lng
        });
      },
      error => {
        console.error(error);
      }
    );
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    if (typeof this.props.user.longitude !== "undefined") {
      this.setState({
        latitude: this.props.user.latitude,
        longitude: this.props.user.longitude
      })
    }
    else{
      this.setState({
        latitude: -20.697846,
        longitude: -44.826184,
      })
    }
    console.log(this.props)
  }
  handleInputChange (event) {
    // get target
    const target = event.target;
    // if checkbox or input field
    const value = target.type === 'checkbox' ? target.checked : target.value;
    // get tag name
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  toggle(refresh){
    if('geolocation' in navigator){
      const refThis = this
      navigator.geolocation.getCurrentPosition(
        function(position){
          if( position.coords.latitude !== 0 && position.coords.longitude !== 0 ){
            refThis.setState({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            });
          }
        },
        function(error){
          console.log(error);
        }
      );
    }
    this.setState({
      id: '',
      spot_number: '',
      address: '',
      address_number: '',
      status: null,
      statusInvalid: false,
      report: false,
      color_message: '',
      error_message: '',
    });
    this.closed(refresh);
  }
  closed(refresh){
    if(refresh){
      this.setState({ show_form : false, reload : !this.state.reload, editing : null} )
    }else{
      this.setState({ show_form : false, editing : null})
    }
  }
  alterStatusSpot(obj){
    this.setState({
      show_form: true,
      id : obj.id,
      status: obj.status,
      spot_number: obj.spot_number,
      address: obj.address,
      address_number: obj.address_number,
    });
  }
  register() {
    if (this.state.status===null || this.state.status.length<=0) {
      this.setState({statusInvalid : true});
      return false;
    } else {
      this.setState({statusInvalid : false});
    }
    this.setState({loading : true});
    let url = BaseService.ENDPOINT + 'admin/dashboard-parking-spot/'+this.state.id;
    var form = new FormData();
    form.append("status", this.state.status.id);
    form.append("report", this.state.report);
    return fetch(url, {
      method: 'POST',
      headers: new Headers({
        'Accept': 'application/json',
        'Authorization' : 'Bearer ' + this.props.user.access_token,
      }),
      body : form
    })
    .then((response) => response.json())
    .then((json) => {
      if(json.return.code === 1){
        this.setState({
          loading : true,
          error_message : 'Vaga alterada com sucesso!',
          color_message: 'success'
        });
      } else if(json.return.code>300){
        window.location = '/';
      } else {
        this.setState({
          loading: true,
          error_message: json.return.message
        });
      }
    });
  }
  render() {
    return (
      <Page
        className="DashboardPage"
        title="Dashboard">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div className='DivGoogleMapReact'>
                  <PinLocalization
                    fatherNode={GoogleMapReact}
                    user={this.props.user}
                    api="admin/dashboard-parking-spot"
                    lat={this.state.latitude}
                    lng={this.state.longitude}
                    alterStatusSpot={this.alterStatusSpot}
                    toggle={this.closed}
                    reload={this.state.reload}
                  />
                </div>
                <Modal isOpen={this.state.show_form} >
                  <ModalHeader><strong>Número da Vaga:</strong> {this.state.spot_number}<br /><strong>Endereço:</strong> {this.state.address}, Nº {this.state.address_number} </ModalHeader>
                  <ModalBody hidden={this.state.loading}>
                    <Form>
                      <SelectAPI
                        label={Strings.status}
                        name="status"
                        placeholder={"Selecione o "+Strings.status+" da vaga"}
                        access_token={this.props.user.access_token}
                        api="admin/parking-spot-status"
                        selectedOption={this.handleInputChange}
                        value={this.state.status}
                        invalid={this.state.statusInvalid}
                        formFeedbackMsg={Strings.required_field}
                        multi={false} />
                      <FormGroup>
                        <Label>Reportar ao Fiscal</Label><br />
                        <ButtonGroup size="md">
                          <Button
                            outline
                            onClick={() => this.setState({ report: true })}
                            active={this.state.report === true}
                            style={{ zIndex: 0 }}
                            color="primary">Sim</Button>
                          <Button
                            outline
                            onClick={() => this.setState({ report: false })}
                            active={this.state.report === false}
                            style={{ zIndex: 0 }}
                            color="danger">Não</Button>
                        </ButtonGroup>
                      </FormGroup>
                    </Form>
                  </ModalBody>
                  <Loader
                    body={ModalBody}
                    hidden={!this.state.loading}
                    message={this.state.error_message}
                    color_message={this.state.color_message}
                    onClose={() => this.setState({loading: false, error_message: '', color_message: ''})}
                    onCloseSuccess={() => {this.toggle(true); this.setState({loading: false, error_message: '', color_message: ''});}}
                  />
                  <ModalFooter hidden={this.state.loading} >
                    <Button outline color="primary" onClick={this.register.bind(this)}>Salvar</Button>
                    <Button outline color="danger" onClick={() => this.toggle(false)}>Cancelar</Button>
                  </ModalFooter>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}

// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
  const currentUser = loginSelectors.getUser(state);
  return {
    user : currentUser
  };
}
export default connect(mapStateToProps)(DashboardPage)



// WEBPACK FOOTER //
// ./src/pages/DashboardPage.js